module.exports = {
    atlasParser: require('./atlasParser'),
    Loader: require('./Loader')
};
